import React from 'react';
import { Link } from 'react-router-dom';
import ExploreButton from '../components/ExploreButton';
import SEO from '../components/SEO';
import '../styles/pages/NotFoundPage.css';

const NotFoundPage = () => {
  return (
    <>
      <SEO
        title="Page Not Found | Supernova Lab"
        description="Looks like you've ventured into uncharted territory."
        keywords="about supernova lab, innovation lab, public experimentation, Barbados innovation, government innovation"
        ogImage="https://supernovalab.bb/assets/images/og-about.jpg"
        canonicalUrl="https://supernovalab.bb/about-us"
      />
      <main className="not-found-page">
        <section className="not-found-section">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-8 text-center">
                {/* 404 Number */}
                <div className="error-code-wrapper">
                  <h1 className="error-code">
                    <span className="text-gradient-cyan">4</span>
                    <span className="text-gradient-purple">0</span>
                    <span className="text-gradient-orange">4</span>
                  </h1>
                </div>

                {/* Error Message */}
                <h2 className="error-title">Page Not Found</h2>
                <p className="error-description">
                  Looks like you've ventured into uncharted territory.<br />
                  The page you're looking for doesn't exist or has been moved.
                </p>

                {/* Action Buttons */}
                <div className="error-actions">
                  <ExploreButton to="/">
                    Back to Home
                  </ExploreButton>

                  <Link to="/about-us" className="btn-text-link">
                    Learn About Us
                  </Link>
                </div>

                {/* Helpful Links */}
                <div className="helpful-links">
                  <h3 className="helpful-links-title">You might be looking for:</h3>
                  <div className="helpful-links-grid">
                    <Link to="/tools" className="helpful-link-card">
                      <i className="fas fa-tools helpful-link-icon"></i>
                      <span>Tools & Resources</span>
                    </Link>
                    <Link to="/blog" className="helpful-link-card">
                      <i className="fas fa-blog helpful-link-icon"></i>
                      <span>Lab Notes</span>
                    </Link>
                    <Link to="/get-involved" className="helpful-link-card">
                      <i className="fas fa-handshake helpful-link-icon"></i>
                      <span>Get Involved</span>
                    </Link>
                    <Link to="/whats-next" className="helpful-link-card">
                      <i className="fas fa-calendar-alt helpful-link-icon"></i>
                      <span>What's Next</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default NotFoundPage;